import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_searchComponent = _resolveComponent("searchComponent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_tableComponent = _resolveComponent("tableComponent")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, {
    shadow: "never",
    class: "container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_searchComponent, {
        "search-list": _ctx.searchList,
        "onUpdate:searchList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchList) = $event)),
        "button-list": _ctx.buttonList,
        onDoSearch: _ctx.handleSearch
      }, null, 8, ["search-list", "button-list", "onDoSearch"]),
      _createVNode(_component_tableComponent, {
        class: "mg-t-12",
        "table-data": _ctx.tableData,
        "table-head": _ctx.tableHead,
        "row-key": _ctx.getRowKeys,
        onSelectionChange: _ctx.handleSelectionChange,
        "page-info": _ctx.pageInfo,
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange
      }, {
        status: _withCtx((scope) => [
          _createElementVNode("div", null, _toDisplayString(_ctx.statusMap(scope.row.status)), 1)
        ]),
        operate: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.basicInfo.state === 1 && (scope.row.status === 4 || scope.row.status === 0))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  class: "link",
                  type: "text",
                  size: "small",
                  onClick: ($event: any) => (_ctx.stopPay(scope.row.id))
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" 停止发薪 ")
                  ])),
                  _: 2
                }, 1032, ["onClick"]))
              : (scope.row.status === 1 && scope.row.billStatus === 0)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    class: "link",
                    type: "text",
                    size: "small",
                    onClick: ($event: any) => (_ctx.applyBill(scope.row.batchNo, scope.row.detailOrderNo, scope.row.id))
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" 申请回单 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : (scope.row.status === 1 && scope.row.billStatus === 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      class: "link",
                      type: "text",
                      size: "small",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$message.success('回单正在生成中，请耐心等待！')))
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" 回单生成中 ")
                      ])),
                      _: 1
                    }))
                  : (scope.row.status === 1 && scope.row.billStatus === 2)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        onClick: ($event: any) => (_ctx.downloadBill(scope.row.batchNo, scope.row.detailOrderNo, scope.row.id)),
                        class: "link",
                        type: "text",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" 下载回单 ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 4,
                        class: "link",
                        type: "text",
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode(" 不可操作 ")
                        ])),
                        _: 1
                      }))
          ])
        ]),
        _: 1
      }, 8, ["table-data", "table-head", "row-key", "onSelectionChange", "page-info", "onSizeChange", "onCurrentChange"])
    ]),
    _: 1
  }))
}